import { apiFetch } from "@/client/lib/api";

/**
 * Typed client for the customer-facing documentation API. Content is served
 * from the portal's own store (a snapshot of Outline), so these are plain
 * tenant-scoped reads - no Outline credentials ever reach the browser.
 */

export interface DocNavPage {
  id: string;
  slug: string;
  title: string;
  sourceId: string;
  outlineDocumentId: string;
  parentOutlineDocumentId: string | null;
  position: number;
}

export interface DocPageContent {
  id: string;
  slug: string;
  title: string;
  content: string;
  outlineUpdatedAt: string | null;
}

/** A guide resolved for the caller's tenant and ready to link to. */
export interface ResolvedPlacement {
  slot: string;
  slug: string;
  title: string;
  description: string | null;
  position: number;
}

export const docsApi = {
  listPages: () => apiFetch<{ pages: DocNavPage[] }>("/docs"),
  getPage: (slug: string) => apiFetch<DocPageContent>(`/docs/${encodeURIComponent(slug)}`),
  listPlacements: () => apiFetch<{ placements: ResolvedPlacement[] }>("/docs/placements"),
};
